import { useState } from 'react'

import AssistantChat from './AssistantChat'
import AssistantDrawer from './AssistantDrawer'
import AssistantFab from './AssistantFab'
import useAssistantAccess from './useAssistantAccess'
import useAssistantChat from './useAssistantChat'

/**
 * The Civitas Learning AI assistant UI: a floating action button that opens a
 * side drawer containing the chat interface.
 */
const AssistantShell = () => {
  const [isOpen, setIsOpen] = useState(false)
  const {
    messages,
    loading,
    sendMessage,
    stopGeneration,
    clearHistory,
    inProgressText,
    currentStatus
  } = useAssistantChat()

  return (
    <>
      <AssistantFab isOpen={isOpen} onClick={() => setIsOpen((prev) => !prev)} />
      <AssistantDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onClearHistory={messages.length > 0 ? clearHistory : undefined}
      >
        <AssistantChat
          messages={messages}
          loading={loading}
          sendMessage={sendMessage}
          stopGeneration={stopGeneration}
          inProgressText={inProgressText}
          currentStatus={currentStatus}
        />
      </AssistantDrawer>
    </>
  )
}

/**
 * Gates the Civitas Learning AI assistant panel behind the PLANNING_AI_ASSISTANT
 * institution feature flag and the PlanningAiAssistant user permission.
 * Civitas employees are auto-granted the permission but still require the flag.
 */
const Assistant = () => {
  const { isEnabled } = useAssistantAccess()

  if (!isEnabled) return null

  return <AssistantShell />
}

export default Assistant
